import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Gain } from "../../core/context/Gain";
import { ToneAudioNode } from "../../core/context/ToneAudioNode";
import { optionsFromArguments } from "../../core/util/Defaults";
import { Merge } from "./Merge";
/**
 * Mono coerces the incoming mono or stereo signal into a mono signal
 * where both left and right channels have the same value. This can be useful
 * for [stereo imaging](https://en.wikipedia.org/wiki/Stereo_imaging).
 * @category Component
 */
export var Mono = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Mono, _ToneAudioNode);
  function Mono() {
    var _this;
    _classCallCheck(this, Mono);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Mono).call(this, optionsFromArguments(Mono.getDefaults(), arguments)));
    _this.name = "Mono";
    _this.input = new Gain({
      context: _this.context
    });
    _this._merge = _this.output = new Merge({
      channels: 2,
      context: _this.context
    });
    _this.input.connect(_this._merge, 0, 0);
    _this.input.connect(_this._merge, 0, 1);
    return _this;
  }
  _createClass(Mono, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Mono.prototype), "dispose", this).call(this);
      this._merge.dispose();
      this.input.dispose();
      return this;
    }
  }]);
  return Mono;
}(ToneAudioNode);